var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSawit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Palm_Oil",
    "data-name": "Palm Oil",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sawit",
    transform: "translate(0 -0.183)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(0 0.183)",
    fill: "#e23d33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M0,0H19.672",
    transform: "translate(11.681 32.183)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6068",
    "data-name": "Path 6068",
    d: "M0,0H10.357",
    transform: "translate(16.428 34.22)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5055",
    "data-name": "Group 5055",
    transform: "translate(8.315 8.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6052",
    "data-name": "Path 6052",
    d: "M-19073.344-4572.876h-9.738a.448.448,0,0,1-.406-.354c-.1-.354,2.674-2.019,5.6-2.17a15.051,15.051,0,0,1,5.047.555",
    transform: "translate(19083.49 4587.572)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6053",
    "data-name": "Path 6053",
    d: "M-19075.1-4621.084s-5.107-1.492-6.092-1.732,3.973-1.582,7.168-.477,4.119,2.06,4.119,2.06",
    transform: "translate(19081.438 4633.239)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6054",
    "data-name": "Path 6054",
    d: "M-19022.232-4695.749s-4.119-4.145-4.539-4.658,3.072.466,5.225,2.1a12.825,12.825,0,0,1,3.395,4.425",
    transform: "translate(19029.898 4705.867)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6055",
    "data-name": "Path 6055",
    d: "M-18972.641-4737.332s-2.133-3.727-2.523-4.425,2.746.941,4.387,3.183a18.446,18.446,0,0,1,2.449,5.707",
    transform: "translate(18981.105 4744.985)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6056",
    "data-name": "Path 6056",
    d: "M-18920.449-4775.7s-.818-3.028-1.437-4.93,2.629,1.64,3.609,4.348a13.437,13.437,0,0,1,.428,5.939",
    transform: "translate(18930.777 4782.093)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6057",
    "data-name": "Path 6057",
    d: "M-18814.312-4572.932s8.037-.155,9.473,0-2.164-1.854-4.854-2.251a13.591,13.591,0,0,0-5.549.583",
    transform: "translate(18829.881 4587.438)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6058",
    "data-name": "Path 6058",
    d: "M-18820.75-4618.59s4.111-1.086,5.7-1.513-2.93-1.262-5.7-.854a12.476,12.476,0,0,0-5.164,2.291",
    transform: "translate(18839.969 4630.727)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6059",
    "data-name": "Path 6059",
    d: "M-18829.434-4696.458s3.533-3.416,4.311-4.231-2.33,0-4.7,1.747a16.227,16.227,0,0,0-3.92,4.542",
    transform: "translate(18847.369 4706.305)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6060",
    "data-name": "Path 6060",
    d: "M-18842.393-4738.219s1.9-3.495,2.486-4.387-1.9.155-4.039,2.64a12.312,12.312,0,0,0-2.6,5.512",
    transform: "translate(18859.475 4745.931)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6061",
    "data-name": "Path 6061",
    d: "M-18850-4777.333a16.443,16.443,0,0,1,1.432-2.873,6.8,6.8,0,0,1,2.289-2.485c.318-.019-.029,1.067-.389,2.33-.389,1.378-.971,3.261-.971,3.261",
    transform: "translate(18862.74 4783.531)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6062",
    "data-name": "Path 6062",
    d: "M-18870.732-4794.423s1.9-4.735,1.979-3.454,0,3.881,0,3.881",
    transform: "translate(18882.344 4798.097)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3883",
    "data-name": "Ellipse 3883",
    transform: "translate(12.321 11.751)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.346,
    cy: 1.346,
    r: 1.346,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.346,
    cy: 1.346,
    r: 0.846,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3884",
    "data-name": "Ellipse 3884",
    transform: "translate(10.527 11.751)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.346,
    cy: 1.346,
    r: 1.346,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.346,
    cy: 1.346,
    r: 0.846,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3885",
    "data-name": "Ellipse 3885",
    transform: "translate(9.629 13.545)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.346,
    cy: 1.345,
    rx: 1.346,
    ry: 1.345,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.346,
    cy: 1.345,
    rx: 0.846,
    ry: 0.845,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3887",
    "data-name": "Ellipse 3887",
    transform: "translate(13.218 13.545)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.345,
    cy: 1.345,
    r: 1.345,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.345,
    cy: 1.345,
    r: 0.845,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3886",
    "data-name": "Ellipse 3886",
    transform: "translate(11.424 13.545)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.346,
    cy: 1.345,
    rx: 1.346,
    ry: 1.345,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.346,
    cy: 1.345,
    rx: 0.846,
    ry: 0.845,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6063",
    "data-name": "Path 6063",
    d: "M-18824.854-4513.777s1.053,7.362.822,7.4a6.544,6.544,0,0,1-.887,0",
    transform: "translate(18839.006 4529.292)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6064",
    "data-name": "Path 6064",
    d: "M-18817.877-4513.777s-.467,2.232-.943,5.417a11.072,11.072,0,0,0-.285,1.983c.234.039,2.785,0,2.785,0",
    transform: "translate(18829.152 4529.292)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6065",
    "data-name": "Path 6065",
    d: "M-18879.973-4489.236a9.972,9.972,0,0,0,.816.737c.061,0,.775-.743.854-.737s.729.735.777.737a9.608,9.608,0,0,0,.7-.737",
    transform: "translate(18891.08 4506.09)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6066",
    "data-name": "Path 6066",
    d: "M-18879.973-4489.236a9.972,9.972,0,0,0,.816.737c.061,0,.775-.743.854-.737s.729.735.777.737a9.608,9.608,0,0,0,.7-.737",
    transform: "translate(18891.08 4508.218)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6067",
    "data-name": "Path 6067",
    d: "M-18879.973-4489.236a13.5,13.5,0,0,0,1.035.964c.078,0,.992-.972,1.09-.964s.924.961.984.964a12.077,12.077,0,0,0,.891-.964",
    transform: "translate(18890.6 4510.01)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSawit);
export default __webpack_public_path__ + "static/media/Sawit.31b981217517bfa4f99fb002a0c891d8.svg";
export { ForwardRef as ReactComponent };